export enum ContactRequestStatus {
  "Received" = 0,
  "Being Processed" = 1,
  "Closed" = 9,
}